<template>
  <v-layout align-center wrap>
    <v-flex xs2>
      <h3 class="subheading grey--text text--darken-2">タイムゾーン</h3>
    </v-flex>
    <v-flex xs10>
      <v-select
        v-model="selectItem"
        :items="items"
        item-value="id"
        item-text="name"
        style="max-width: 320px;"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import timeZone from '@/constants/timeZone'
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      items: timeZone,
    }
  },
  computed: {
    selectItem: {
      get() {
        return this.value
      },
      set(text) {
        this.$emit('input', text)
      },
    },
  },
}
</script>
